import {
  add,
  eachDayOfInterval,
  endOfMonth,
  format,
  getDay,
  isSameDay,
  isSameMonth,
  isToday,
  parse,
  startOfToday,
  setYear,
  setHours,
  setMinutes,
  eachYearOfInterval,
  getYear,
  eachMonthOfInterval,
  endOfYear,
  startOfYear,
  setMonth
} from 'date-fns-jalali';

// import { faIR } from 'date-fns/locale'
import { faIR } from 'date-fns-jalali/locale';
import { useCallback, useEffect, useState } from 'react';

// import './datepicker.css';

import { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon
} from '@heroicons/react/20/solid';
import { getArrayFilled } from '../../../utils/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function classNames(...classes: any): string {
  return classes.filter(Boolean).join(' ');
}

const colStartClasses = [
  'col-start-2',
  'col-start-3',
  'col-start-4',
  'col-start-5',
  'col-start-6',
  'col-start-7',
  ''
];

interface SelectProps {
  label?: string | boolean;
  colors: {
    textColor: string;
    backgroundColor: string;
    primary: string;
    buttonBackground: string;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultId: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultName: any;
  data: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    id: any;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    name: any;
  }[];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelect: (val: { name: any; id: any }) => void;
  justifyAlign: string;
}

export default function Select({
  label,
  colors,
  defaultId,
  defaultName,
  data,
  onSelect,
  justifyAlign
}: SelectProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [selectedOption, setSelectedOption] = useState<{ name: any; id: any }>({
    id: defaultId,
    name: defaultName
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSelect = useCallback((val: { name: any; id: any }) => {
    onSelect(val);
    setSelectedOption(val);
  }, []);

  useEffect(() => {
    setSelectedOption({ id: defaultId, name: defaultName });
  }, [defaultId, defaultName]);
  return (
    <Listbox value={selectedOption} onChange={handleSelect}>
      {({ open }: { open: boolean }) => (
        <>
          {label ? (
            <Listbox.Label
              className="block text-sm font-medium leading-6 text-gray-100 text-center"
              style={{ color: colors.textColor }}>
              {label}
            </Listbox.Label>
          ) : null}
          <div className="relative w-full">
            <Listbox.Button
              className={`relative w-full cursor-default rounded-md py-.5 pr-2 pl-2 focus:outline-none sm:text-xs sm:leading-6 cursor-pointer`}
              style={{ color: colors.textColor, backgroundColor: colors.buttonBackground }}>
              <span className={`flex items-center ${justifyAlign}`}>
                <span className="block truncate">{selectedOption.name}</span>
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-out duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
              enter="transition ease-in duration-100"
              enterFrom="opacity-0"
              enterTo="opacity-100">
              <div
                className="px-0.5 py-1 absolute z-10 max-h-56 w-full shadow-lg rounded-md ring-black ring-opacity-5 focus:outline-none sm:text-xs"
                style={{ backgroundColor: colors.backgroundColor }}>
                <Listbox.Options className="datepicker-scrollbar w-100 max-h-52 overflow-auto text-center focus:outline-none mb-0">
                  {data.map((item) => (
                    <Listbox.Option
                      key={item.id}
                      className={({ active }: { active: boolean }) =>
                        classNames(
                          active ? 'text-white' : 'text-gray-300',
                          'flex items-center justify-center px-0 rounded rounded-md py-0.5 cursor-pointer'
                        )
                      }
                      value={item}>
                      {({ selected, active }: { selected: boolean; active: boolean }) => (
                        <div
                          className={classNames(
                            active || selected ? 'bg-red-500 text-white ' : 'text-gray-300',
                            'flex items-center justify-center px-1 rounded rounded-sm py-0.5 w-[100%]'
                          )}
                          style={active || selected ? { backgroundColor: colors.primary } : {}}>
                          <div
                            className={classNames(
                              selected ? 'font-bold' : 'font-normal',
                              'block truncate'
                            )}>
                            {item.name}
                          </div>
                        </div>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </div>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
}

interface DatepickerProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultDate?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelectDate?: any;
  open: boolean;
  hideTime?: boolean;
  hideToday?: boolean;
  hideConfirm?: boolean;
  setOpen: (state: boolean) => unknown;
}
export const DatePicker = ({
  defaultDate,
  onSelectDate,
  open,
  setOpen,
  hideTime,
  hideToday,
  hideConfirm
}: DatepickerProps) => {
  const colors = {
    backgroundColor: '#f2e9ec',
    textPrimaryColor: 'text-[#7f2144]',
    borderPrimaryColor: 'border-[#7f2144]',
    bgPrimaryColor: 'bg-[#7f2144]',
    primaryHoverColor: 'hover:bg-[#7f2144]',
    selectedText: 'text-[#f2e9ec]',
    selectedHoverText: 'hover:text-[#d9bcc7]',
    defaultText: '#661a36',
    borderBg: 'border-[#bf90a2]',
    hoverBg: 'hover:bg-[#bf90a2]',
    hoverText: 'hover:text-[#7f2144]'
  };
  const today = startOfToday();
  const [selectedDay, setSelectedDay] = useState(defaultDate ?? today);
  const [currentMonth, setCurrentMonth] = useState(format(today, 'MMM-yyyy', { locale: faIR }));
  const firstDayCurrentMonth = parse(currentMonth, 'MMM-yyyy', new Date(), { locale: faIR });

  const days = eachDayOfInterval({
    start: firstDayCurrentMonth,
    end: endOfMonth(firstDayCurrentMonth)
  });

  const startDate = startOfYear(today);
  const endDate = endOfYear(today);

  const months = eachMonthOfInterval({ start: startDate, end: endDate });
  const monthList = months.map((month) => format(month, 'MMMM'));

  const [firstYear] = useState(today);
  const years = eachYearOfInterval({
    start: add(firstYear, { years: -5 }),
    end: add(firstYear, { years: 10 })
  });

  const [allowClose, setAllowClose] = useState(true);
  const [hour, setHour] = useState(12);
  const [gzbz, setGzbz] = useState<string>('ق.ظ.');
  const [minute, setMinute] = useState(0);

  const getNewSelectedDateWithTime = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (selectedDateWithoutTime: any) => {
      const newMinute = setMinutes(selectedDateWithoutTime, minute);
      let hr = 5;
      if (gzbz === 'ق.ظ.') {
        if (hour === 12) {
          hr = hour + 12;
        } else {
          hr = hour;
        }
      } else {
        if (hour !== 12) {
          hr = hour + 12;
        } else {
          hr = hour;
        }
      }
      hr = hr === 24 ? 0 : hr;
      console.log(hr);
      const newTime = setHours(newMinute, hr);
      return newTime;
    },
    [hour, minute, gzbz]
  );

  function previousMonth() {
    const firstDayNextMonth = add(firstDayCurrentMonth, { months: -1 });
    setCurrentMonth(format(firstDayNextMonth, 'MMM-yyyy', { locale: faIR }));
  }

  function nextMonth() {
    const firstDayNextMonth = add(firstDayCurrentMonth, { months: 1 });
    setCurrentMonth(format(firstDayNextMonth, 'MMM-yyyy', { locale: faIR }));
  }

  function nextYear() {
    const firstDayNextMonth = add(firstDayCurrentMonth, { years: 1 });
    setCurrentMonth(format(firstDayNextMonth, 'MMM-yyyy', { locale: faIR }));
  }
  function previousYear() {
    const firstDayNextMonth = add(firstDayCurrentMonth, { years: -1 });
    setCurrentMonth(format(firstDayNextMonth, 'MMM-yyyy', { locale: faIR }));
  }
  const setTheYear = useCallback(
    (year: number) => {
      const newYear = setYear(selectedDay, year);
      setCurrentMonth(format(newYear, 'MMM-yyyy', { locale: faIR }));
    },
    [selectedDay]
  );

  const setTheMonth = useCallback(
    (month: number) => {
      const newMonth = setMonth(selectedDay, month);
      setCurrentMonth(format(newMonth, 'MMM-yyyy', { locale: faIR }));
    },
    [selectedDay]
  );

  const setTheMinute = useCallback(
    (min: number) => {
      setMinute(min);
    },
    [selectedDay]
  );

  const setTheHour = useCallback(
    (hr: number) => {
      setHour(hr);
    },
    [selectedDay]
  );

  const setTheGzbz = useCallback((gb: string) => {
    setGzbz(gb);
  }, []);

  useEffect(() => {
    const newTime = getNewSelectedDateWithTime(selectedDay);
    setSelectedDay(newTime);
    setAllowClose(false);
  }, [hour, minute, gzbz]);

  useEffect(() => {
    setCurrentMonth(format(selectedDay, 'MMM-yyyy', { locale: faIR }));
    if (onSelectDate) {
      onSelectDate(selectedDay);
      setAllowClose(true);
    }

    if (allowClose) {
      setOpen(false);
      setAllowClose(true);
    }
  }, [selectedDay]);

  const setDateToToday = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newTime: any = getNewSelectedDateWithTime(startOfToday());
    setSelectedDay(newTime);
    setCurrentMonth(format(newTime, 'MMM-yyyy', { locale: faIR }));
  }, [hour, minute, gzbz]);

  return (
    <div
      className="font-fd rounded-md"
      dir="rtl"
      style={{
        display: !open ? 'none' : 'block',
        width: 280,
        backgroundColor: colors.backgroundColor,
        marginInline: 'auto',
        boxShadow: '0px 30px 45px 0px rgba(0,0,0,0.30)'
      }}>
      <div className="px-3 pt-3 flex gap-2 justify-between">
        {hideToday ? null : (
          <button
            type="button"
            className={`block rounded-md ${colors.hoverBg} ${colors.primaryHoverColor} ${colors.hoverText} ${colors.selectedHoverText} w-[50%] p-1`}
            onClick={setDateToToday}>
            امروز
          </button>
        )}

        {hideTime ? null : (
          <div className="flex items-center justify-between gap-1">
            <div className="w-[3rem] flex items-center">
              <Select
                colors={{
                  textColor: 'var(--rs-primary-500)',
                  backgroundColor: '#eee',
                  buttonBackground: '#eee',
                  primary: '#bbb'
                }}
                data={['ق.ظ.', 'ب.ظ.'].map((gzBz) => {
                  return { id: gzBz, name: gzBz };
                })}
                defaultName={gzbz}
                defaultId={gzbz}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onSelect={(val: { name: any; id: any }) => setTheGzbz(val.name)}
                justifyAlign={'justify-center'}
              />
            </div>
            <div className="w-[2.5rem] flex items-center">
              <Select
                colors={{
                  textColor: 'var(--rs-primary-500)',
                  backgroundColor: '#eee',
                  primary: '#bbb',
                  buttonBackground: '#eee'
                }}
                data={getArrayFilled(60).map((minutee) => {
                  return { id: minutee, name: minutee < 10 ? `0${minutee}` : `${minutee}` };
                })}
                defaultName={minute < 10 ? `0${minute}` : `${minute}`}
                defaultId={minute}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onSelect={(val: { name: any; id: any }) => {
                  setTheMinute(val.id);
                }}
                justifyAlign={'justify-center'}
              />
            </div>
            :
            <div className="w-[2.5rem] flex items-center">
              <Select
                colors={{
                  textColor: 'var(--rs-primary-500)',
                  backgroundColor: '#eee',
                  buttonBackground: '#eee',
                  primary: '#bbb'
                }}
                data={getArrayFilled(12, 1)
                  .splice(1)
                  .map((hourr) => {
                    return { id: hourr, name: hourr < 10 ? `0${hourr}` : `${hourr}` };
                  })}
                defaultName={hour < 10 ? `0${hour}` : `${hour}`}
                defaultId={hour}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onSelect={(val: { name: any; id: any }) => setTheHour(val.id)}
                justifyAlign={'justify-center'}
              />
            </div>
          </div>
        )}
      </div>
      <div className="max-w-md p-3">
        <div>
          <div>
            <div className="flex items-center justify-between" dir="ltr">
              <div className="flex gap-0-5">
                <button
                  onClick={previousYear}
                  type="button"
                  className={`ml-1 flex items-center justify-center rounded-md p-1 border ${colors.borderBg} ${colors.hoverBg}`}>
                  <span className="sr-only">Previous year</span>
                  <ChevronDoubleLeftIcon
                    className="h-4 w-4"
                    style={{ color: 'var(--rs-primary-500)' }}
                    aria-hidden="true"
                  />
                </button>

                <button
                  type="button"
                  onClick={previousMonth}
                  className={` flex items-center justify-center rounded-md p-1 border ${colors.borderBg} ${colors.hoverBg}`}>
                  <span className="sr-only">Previous month</span>
                  <ChevronLeftIcon
                    className="h-4 w-4"
                    style={{ color: 'var(--rs-primary-500)' }}
                    aria-hidden="true"
                  />
                </button>
              </div>

              <div className="flex" dir="rtl">
                <div className="w-[4rem]">
                  <Select
                    colors={{
                      textColor: 'var(--rs-primary-500)',
                      backgroundColor: '#eee',
                      primary: '#bbb',
                      buttonBackground: 'transparent'
                    }}
                    data={years.map((year) => {
                      const yr = getYear(year);
                      return { id: yr, name: yr };
                    })}
                    defaultName={getYear(firstDayCurrentMonth)}
                    defaultId={getYear(firstDayCurrentMonth)}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onSelect={(val: { name: any; id: any }) => {
                      console.log(val.name);
                      setTheYear(val.name);
                    }}
                    justifyAlign={'justify-end'}
                  />
                </div>

                <div className="w-[5.5rem]">
                  <Select
                    colors={{
                      textColor: 'var(--rs-primary-500)',
                      backgroundColor: '#eee',
                      primary: '#bbb',
                      buttonBackground: 'transparent'
                    }}
                    data={monthList.map((month, index) => {
                      return { id: index, name: month };
                    })}
                    defaultName={format(firstDayCurrentMonth, 'MMMM', { locale: faIR })}
                    defaultId={format(firstDayCurrentMonth, 'MMMM', { locale: faIR })}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onSelect={(val: { name: any; id: any }) => setTheMonth(val.id)}
                    justifyAlign={'justify-start'}
                  />
                </div>
              </div>

              <div className="flex gap-0-5">
                <button
                  onClick={nextMonth}
                  type="button"
                  className={`flex flex-none items-center justify-center rounded-md p-1 border ${colors.borderBg} ${colors.hoverBg}`}>
                  <span className="sr-only">Next month</span>
                  <ChevronRightIcon
                    className="h-4 w-4"
                    style={{ color: 'var(--rs-primary-500)' }}
                    aria-hidden="true"
                  />
                </button>

                <button
                  type="button"
                  onClick={nextYear}
                  className={`mr-1 flex flex-none items-center justify-center rounded-md p-1 border ${colors.borderBg} ${colors.hoverBg}`}>
                  <span className="sr-only">Next year</span>
                  <ChevronDoubleRightIcon
                    className="h-4 w-4"
                    style={{ color: 'var(--rs-primary-500)' }}
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>

            <div className="grid grid-cols-7 mt-2 text-xs leading-6 text-center text-gray-500">
              <div>ش</div>
              <div>ی</div>
              <div>د</div>
              <div>س</div>
              <div>چ</div>
              <div>پ</div>
              <div>ج</div>
            </div>
            <div className="grid grid-cols-7 mt-1 text-sm">
              {days.map((day, dayIdx) => (
                <div
                  key={day.toString()}
                  className={classNames(dayIdx === 0 && colStartClasses[getDay(day)], 'py-0.5')}>
                  <button
                    type="button"
                    onClick={() => setSelectedDay(getNewSelectedDateWithTime(day))}
                    className={classNames(
                      isSameDay(day, selectedDay) && `${colors.selectedText}`,
                      !isSameDay(day, selectedDay) &&
                        isToday(day) &&
                        `${colors.textPrimaryColor} border ${colors.borderPrimaryColor} `,
                      !isSameDay(day, selectedDay) &&
                        !isToday(day) &&
                        isSameMonth(day, firstDayCurrentMonth) &&
                        `text-[${colors.defaultText}]`,
                      !isSameDay(day, selectedDay) &&
                        !isToday(day) &&
                        !isSameMonth(day, firstDayCurrentMonth) &&
                        'text-gray-400',
                      isSameDay(day, selectedDay) &&
                        isToday(day) &&
                        `${colors.bgPrimaryColor} ${colors.selectedText}`,
                      isSameDay(day, selectedDay) &&
                        !isToday(day) &&
                        `${colors.bgPrimaryColor} ${colors.selectedText}`,
                      !isSameDay(day, selectedDay) && `${colors.hoverBg} ${colors.hoverText}`,
                      (isSameDay(day, selectedDay) || isToday(day)) && 'font-semibold',
                      'mx-auto flex h-8 w-8 items-center justify-center rounded-md'
                    )}>
                    <time dateTime={format(day, 'yyyy-MM-dd')}>{format(day, 'd')}</time>
                  </button>
                </div>
              ))}
            </div>
            {/* <div className="mx-0.5 mt-1">
              <button className={`rounded-md bg-[${colors.primaryColor}] text-[${colors.selectedText}] px-2 p-0.5`} onClick={setDateToToday}>امروز</button>
            </div> */}
            {hideConfirm ? null : (
              <div className="mx-0.5 mt-2 flex">
                <button
                  type="button"
                  className={`rounded-md ${colors.bgPrimaryColor} ${colors.selectedText} w-[100%] p-1`}
                  onClick={() => setOpen(false)}>
                  تایید
                </button>
                {/* <button type="button" className={`rounded-md bg-[${colors.hoverBg}] text-[${colors.hoverText}] w-[47.5%] p-1`}>انصراف</button> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
